const EmptyRouterView = () => /* webpackChunkName: "EmptyRouterView" */ import("./../views/some_hcm/EmptyRouterView.vue");
const SomeHome = () => /* webpackChunkName: "Home" */ import("./../views/some_hcm/Home.vue");
const SomeHcm = () => /* webpackChunkName: "SomeHcm" */ import("./../views/some_hcm/telemedical/SomeHcm.vue");
const FilePatient = () => /* webpackChunkName: "FilePatient" */ import("./../views/some_hcm/telemedical/FilePatient.vue");
const Interconsult = () => /* webpackChunkName: "Interconsult" */ import("./../views/some_hcm/telemedical/Interconsult.vue");
const ArchiveRequest = () => /* webpackChunkName: "ArchiveRequestHome" */ import("./../views/some_hcm/archive_request/ArchiveRequestHome.vue");
const PatientManager = () => /* webpackChunkName: "PatientHome" */ import("./../views/some_hcm/patient/PatientHome.vue");
const MaintainerSchedule = () => /* webpackChunkName: "MaintainerShedule" */ import("../views/some_hcm/MaintainerShedule.vue");
const MaintainerBlockedDay = () => /* webpackChunkName: "MaintainerBlockedDay" */ import("../views/some_hcm/MaintainerBlockedDay.vue");
const MentalHealthArchive = () =>
  /* webpackChunkName: "MentalHealthArchive" */ import("./../views/mental_health_medic/mental_health_archive/MentalHealthArchive.vue");
const ProfesionalManteiner = () => /* webpackChunkName: "ProfesionalManteiner" */ import("./../views/mental_health_medic/ProfesionalManteiner.vue");
const RegisterAtentions = () => /* webpackChunkName: "RegisterAtentions" */ import("./../views/medic_hosp/registerAtention/registerAtentions.vue");
const Document = () => /* webpackChunkName: "Document" */ import("@/views/general/Document.vue");
const Archive = () => /* webpackChunkName: "Archive" */ import("./../views/administrative/archive/Archive.vue");
const PatientHome = () => /* webpackChunkName: "PatientHome" */ import("./../views/service_administrator/patient/PatientHome.vue");

export const routes = [
  {
    path: "/someHcm",
    component: EmptyRouterView,
    children: [
      {
        path: "",
        name: "someHcmHome",
        component: SomeHome,
      },
      {
        path: "teleinterconsulta-some-hcm",
        name: "someHcmTic",
        component: SomeHcm,
      },
      {
        path: "ficha-paciente-some-hcm",
        name: "someHcmFilePatient",
        component: FilePatient,
      },
      {
        path: "interconsulta-some-hcm",
        name: "someHcmInterconsult",
        component: Interconsult,
      },
      {
        path: "solicitud-archivo",
        name: "someHcmArchiveRequest",
        component: ArchiveRequest,
      },
      {
        path: "gestion-paciente",
        name: "someHcmPatientManager",
        component: PatientManager,
      },
      {
        path: "mantenerdor-agenda",
        name: "manteinerScheduleSomeHcm",
        component: MaintainerSchedule,
      },
      {
        path: "mantenerdor-dias-bloqueados",
        name: "manteinerBlockedDaySomeHcm",
        component: MaintainerBlockedDay,
      },
      {
        path: "cartola-salud-mental",
        name: "archiveSomeHcm",
        component: MentalHealthArchive,
      },
      {
        path: "mantenedor-profesionales",
        name: "profesionalManteinerSomeHcm",
        component: ProfesionalManteiner,
      },
      {
        path: "registro-antecedentes",
        name: "medicHospRegisterAtentions",
        component: RegisterAtentions,
      },
      {
        path: "registro-antecedentes",
        name: "someHcmRegisterAtentions",
        component: RegisterAtentions,
      },
      {
        path: "documentacion",
        name: "someHcmDocumentation",
        component: Document,
      },
      {
        path: "archivo",
        name: "someHcmArchive",
        component: Archive,
      },
      {
        path: "gestor-pacientes",
        name: "someHcmPatientHome",
        component: PatientHome,
      },
    ],
  },
];
